/**
 * rounded(단수차 매칭) DSD 셀의 단수차이 칩 라벨.
 *
 * mostProper 매칭의 차이를 우선하고, 없으면 첫 단수차 매칭의 차이를 쓴다.
 * 표기는 DSD-DSD 대사의 formatSumDiffLabel 준용 (부호 + toLocaleString).
 */

import type { DsdParsedCell } from "@/apis/compare/types";

/** 부호 있는 단수차 표기 ("+2"/"-1"). 0·미존재는 단수차가 아니므로 숨긴다. */
export const formatSignedDiff = (
  diff: number | null | undefined,
): string | undefined => {
  if (diff == null || diff === 0) return undefined;
  return (diff > 0 ? "+" : "") + diff.toLocaleString();
};

export const roundedDiffLabel = (cell: DsdParsedCell): string | undefined => {
  const refs = cell.matchedIxdCells ?? [];
  const properCellId = cell.mostProperCell?.cellId;
  const proper = refs.find(
    (r) => r.cellId === properCellId && r.displayDifference != null,
  );
  const ref = proper ?? refs.find((r) => r.displayDifference != null);
  return formatSignedDiff(ref?.displayDifference);
};
